import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ConfirmChangePageModal = ({
  show,
  handleClose,
  handleConfirm
}) => (
  <Modal
    show={show}
    animation={false}
    backdrop='static'
    keyboard={false}
  >
    <Modal.Header onHide={handleClose} closeButton>
      <Modal.Title>Unsaved Changes</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>You have unsaved changes on this page. If you continue, these changes will be lost.</p>
    </Modal.Body>
    <Modal.Footer>
      <Button
        variant='light'
        onClick={handleClose}
      >
        Close
      </Button>
      <Button
        variant='danger'
        onClick={handleConfirm}
      >
        Discard Changes
      </Button>
    </Modal.Footer>
  </Modal>
);

ConfirmChangePageModal.propTypes = {
  /** Prop to show or hide modal */
  show: PropTypes.bool.isRequired,

  /** function to handle the Close button action */
  handleClose: PropTypes.func.isRequired,

  /** onSubmit callback function */
  handleConfirm: PropTypes.func.isRequired
};

export default ConfirmChangePageModal;
